type SessionDateRange = {
    fecha_inicio: string;
    fecha_fin: string;
};

const localDateKey = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/**
 * Elige un único día pertinente para registrar la asistencia de una sesión.
 * Las fechas ISO se comparan como texto para no desplazar el día por UTC.
 */
export const getSessionAttendanceDate = (
    session: SessionDateRange,
    now: Date = new Date(),
): string => {
    const today = localDateKey(now);
    if (today < session.fecha_inicio) return session.fecha_inicio;
    if (today > session.fecha_fin) return session.fecha_fin;
    return today;
};
